import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  RouteReuseStrategy,
  provideRouter,
  withRouterConfig,
  withComponentInputBinding,
} from '@angular/router';
import { MessageService } from 'primeng/api';
import { provideUrlWhitelist } from '@navstation-portal/iframe/util/whitelist';
import {
  REPORT_API_ADAPTER,
  REPORT_API_SERVICE,
  REPORT_DEBUG_API_SERVICE,
  ReportDebugService,
} from '@navstation-portal/reporting/data-access/vessel-report';
import {
  provideBaseApiUrl,
  provideBaseApiV2Url,
} from '@navstation-portal/shared/util/api';
import { provideLoggerConfig } from '@navstation-portal/shared/util/logger';
import { provideSharedHighcharts } from '@navstation-portal/shared/ui/components';
import { provideNavPerformanceUi } from '@navstation-portal/shared/ui/theme';
import { TranslationLoader } from '@navstation-portal/shared/util/translation';
import {
  provideTranslateLoader,
  provideTranslateService,
} from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { VesselReportRouteReuseStrategy } from './vessel-report-route-reuse.strategy';
import { ReportAdapterService } from './reporting-page/report-adapter.service';
import { ReportService } from './reporting-page/report.service';
import { routes } from './app.routes';
import { authInterceptor } from './auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideSharedHighcharts(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
      withComponentInputBinding(),
    ),
    { provide: RouteReuseStrategy, useClass: VesselReportRouteReuseStrategy },
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideTranslateService({
      loader: provideTranslateLoader(TranslationLoader),
    }),
    provideNavPerformanceUi(),
    provideTranslateService({
      loader: provideTranslateLoader(TranslationLoader),
    }),
    MessageService,
    provideUrlWhitelist(['http://localhost:4200']),
    provideLoggerConfig({ includeOrigin: true }),
    provideBaseApiUrl(environment.BASE_URL),
    provideBaseApiV2Url(environment.BASE_URL_V2),
    {
      provide: REPORT_API_SERVICE,
      useExisting: ReportService,
    },
    {
      provide: REPORT_API_ADAPTER,
      useExisting: ReportAdapterService,
    },
    // DEV-ONLY form-rule template debug. Delete this provider with
    // ReportDebugService to remove the template debug UI.
    {
      provide: REPORT_DEBUG_API_SERVICE,
      useExisting: ReportDebugService,
    },
  ],
};
